import React from 'react'
import { Modal, ModalBody, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import TaskService from '../common/util/TaskService';


export default function TimeLogDeleteWarning({timeLogDeleteWarn, setTimeDeleteWarn, deleteTimeLogObj, getAllTimeTrackLogs}) { 
  return ( 
        <Modal
          isOpen={timeLogDeleteWarn}
          backdrop={"static"}
          size="md"
          className="taskComplete-warning"
        >
          <ModalBody>
            <Row>
              <Col sm={12}>
                <FontAwesomeIcon
                  icon={faExclamationTriangle}
                  size="3x"
                  className="text-warning"
                />
                <h5 className="my-2">Time Track Delete Warning</h5>
                <p className="taskComplete-warning-subtitle">
                  Are you sure? you want to delete this log
                </p>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <button
                  onClick={() => {
                    if (deleteTimeLogObj.timelogId) {
                      TaskService.DeleteTimeTrack(deleteTimeLogObj.timelogId)
                        .then((result) => {
                          getAllTimeTrackLogs("all");
                          setTimeDeleteWarn(false);
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                    }
                  }}
                  className="btn btn-primary w-100 mt-2"
                >
                  OK
                </button>
              </Col>
              <Col sm={6}>
                <button
                  onClick={() => {
                    setTimeDeleteWarn(false);
                  }}
                  className="btn btn-secondary w-100 mt-2"
                >
                  Cancel
                </button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>   
  )
}
